
import Vue, { PropType } from 'vue';
import { RulespecDefault, RulespecLightingSettings, RulespecMovement } from '@/interfaces/rules';

export default Vue.extend({
	props: {
		id: { type: String, default: 'rule-table' },
		activeRule: { type: Object as PropType<RulespecMovement>, default: null },
		standByRule: { type: Object as PropType<RulespecMovement>, default: null },
		inactiveRule: { type: Object as PropType<RulespecDefault>, required: true },
		lightingSettingsRule: {
			type: Object as PropType<RulespecLightingSettings>,
			required: true,
		},
	},

	methods: {
		convertMinutes(time: number, reducer: number | null = null): number {
			if (reducer) {
				return Math.floor((time - reducer) / 60);
			} else {
				return Math.floor(time / 60);
			}
		},

		convertSeconds(time: number, reducer: number | null = null): number {
			if (reducer) {
				return (time - reducer) % 60;
			} else {
				return time % 60;
			}
		},
	},
});
